// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'

import JSExtender from '@/core/js-extender'
Vue.use(JSExtender)

import ElementUI from 'element-ui'
Vue.use(ElementUI)

import VueRefStore from 'vue-ref-store'
Vue.use(VueRefStore)

import ZmTreeOrg from 'zm-tree-org'
import 'zm-tree-org/lib/zm-tree-org.css'
Vue.use(ZmTreeOrg)

import QuestionnaireUI from '@/core/questionnaire-ui'
Vue.use(QuestionnaireUI)

import VEllipsis from 'v-directive-ellipsis'
import 'v-directive-ellipsis/dist/ellipsis.css'
Vue.directive('ellipsis', VEllipsis)

import CustomComponents from './components/customComponents'
Vue.use(CustomComponents)

import navigationGuards from './navigationGuards'
Vue.use(navigationGuards)

import VueExtender from '@/core/vue-extender'
Vue.use(VueExtender)

import OSS from '@/script/aliyun-upload-sdk/lib/aliyun-oss-sdk-6.17.1.min'
window.OSS = OSS
import '@/script/aliyun-upload-sdk/aliyun-upload-sdk-1.5.7.min'

import 'whatwg-fetch';
import 'bootstrap/dist/js/bootstrap.min'

import router from './router'
import store from './store/'
import App from './App'

Vue.config.productionTip = false;
window.Promise = Promise;
window.fetch = fetch;

import * as globalFilters from './filters'
Object.keys(globalFilters).forEach(key => {
  Vue.filter(key, globalFilters[key])
})

Vue.directive('draggable', {
  bind: function (el) {
    el.style.position = 'absolute';
    var startX, startY, initialMouseX, initialMouseY;

    function mousemove(e) {
      var dx = e.clientX - initialMouseX;
      var dy = e.clientY - initialMouseY;
      el.style.top = startY + dy + 'px';
      el.style.left = startX + dx + 'px';
      return false;
    }

    function mouseup() {
      document.removeEventListener('mousemove', mousemove);
      document.removeEventListener('mouseup', mouseup);
    }

    el.addEventListener('mousedown', function(e) {
      startX = el.offsetLeft;
      startY = el.offsetTop;
      initialMouseX = e.clientX;
      initialMouseY = e.clientY;
      document.addEventListener('mousemove', mousemove);
      document.addEventListener('mouseup', mouseup);
      return false;
    });
  }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: {
    App
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js